import '../styles/index.scss';

console.log('webpack starterkit');

import { changeLocale } from "./translations";

if(window.location.hash === "#en"){
  changeLocale("en");
} else if(window.location.hash === "#de")  {
  changeLocale("de");
} else if(window.location.hash === "#fr")  {
  changeLocale("fr");
} else {
  changeLocale("de");
}

if(window.innerWidth <= 767) {
  document.querySelector(".content").style.height = window.innerHeight + 'px';

  window.addEventListener('resize',function(){
    document.querySelector(".content").style.height = window.innerHeight + 'px';
  });
}

// const enBtn = document.querySelector(".en-btn");
// enBtn.addEventListener("click", (e) => {
//   e.preventDefault();
//   changeLocale("en");
// });

// const deBtn = document.querySelector(".de-btn");
// deBtn.addEventListener("click", (e) => {
//   e.preventDefault();
//   changeLocale("de");
// });

// const frBtn = document.querySelector(".fr-btn");
// frBtn.addEventListener("click", (e) => {
//   e.preventDefault();
//   changeLocale("fr");
// });

let currentLoc = "de";

function changeLocalOnInterval() {
  if(currentLoc === "de") {
    currentLoc = "en";
  } else if(currentLoc === "en"){
    currentLoc = "fr";
  } else if(currentLoc === "fr"){
    currentLoc = "de";
  }
  changeLocale(currentLoc);
}

setInterval(changeLocalOnInterval, 3000);
